
import { KeywordInfo } from "./seo/KeywordInfo";
import { ScoreCircle } from "./seo/ScoreCircle";
import { TrendChart } from "./seo/TrendChart";
import { CompetitiveAnalysis } from "./seo/CompetitiveAnalysis";
import { AIInsights } from "./seo/AIInsights";
import { KeywordSummary, URLAnalysis } from "@/types/seo";
import Footer from "./Footer";

interface SEOResultsProps {
  score: number;
  metrics: {
    title: string;
    value: number;
    benchmark: number;
  }[];
  checklist: {
    title: string;
    passed: boolean;
    description: string;
  }[];
  keywordData: KeywordSummary;
  urlAnalyses: URLAnalysis[];
  aiInsights?: any[];
}

export const SEOResults = ({ score, keywordData, urlAnalyses, aiInsights }: SEOResultsProps) => {
  const formatMonth = (month: number) => {
    const months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
    return months[month - 1];
  };

  const trendData = keywordData.trend?.map(item => ({
    month: formatMonth(item.month),
    volume: item.search_volume
  })) || [];

  const hasTrendData = trendData.length > 0 && keywordData.volume !== null && keywordData.volume !== undefined;

  return (
    <div className="bg-white min-h-screen">
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        <div className="space-y-6">
          <div className="flex flex-col lg:flex-row lg:justify-between lg:items-start gap-8">
            {/* Score Circle - Shown first on mobile, moved to right on desktop */}
            <div className="block lg:hidden w-full">
              <ScoreCircle score={score} title="Page Score" />
            </div>
            
            {/* Keyword Info Card */}
            <div className="flex-1">
              <KeywordInfo 
                keyword={keywordData.keyword}
                volume={keywordData.volume}
                cpc={keywordData.cpc}
                url={urlAnalyses[0]?.url}
                aiInsights={aiInsights}
              />
            </div>

            {/* Score Circle - Hidden on mobile, shown on desktop */}
            <div className="hidden lg:block w-[300px]">
              <ScoreCircle score={score} title="Page Score" />
            </div>
          </div>

          {hasTrendData && <TrendChart data={trendData} />}
          <CompetitiveAnalysis 
            urlAnalyses={urlAnalyses} 
            keywordData={keywordData}
          />
          {aiInsights && aiInsights.length > 0 && (
            <AIInsights 
              keyword={keywordData.keyword}
              mainUrl={urlAnalyses[0]?.url}
              insights={aiInsights}
            />
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};
